import React from 'react';

/**
 * Simple Metric Card Component
 * Matches the people-search-mockup.html design exactly
 * Simple card with icon, value, and label
 *
 * @param {Object} props
 * @param {string} props.title - Card title/label
 * @param {number|string} props.value - Value to display
 * @param {React.Component} props.icon - Lucide icon component
 * @param {string} props.iconBgColor - Background color for icon (e.g., 'bg-blue-100')
 * @param {string} props.iconColor - Icon color (e.g., 'text-blue-600')
 */
export function SimpleMetricCard({ title, value, icon: Icon, iconBgColor, iconColor }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-3xl font-bold text-gray-900 mt-2">{value}</p>
        </div>
        <div className={`p-3 ${iconBgColor} rounded-lg`}>
          {Icon && <Icon className={`w-6 h-6 ${iconColor}`} />}
        </div>
      </div>
    </div>
  );
}





















